import { InfoOutlineIcon } from "@chakra-ui/icons";
import { Flex, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { useMemo } from "react";
import { SegmentedMessage } from "sms-segments-calculator";
import { MESSAGE_CONTENT_LIMIT } from "src/constants";
import { maybePluralize } from "src/services/format";

// @deprecated SegmentedMessagePlugin will be used instead of this component
export const SmsInputStats: React.FC<{
  value: string;
  maxSmsLength?: number;
}> = ({ value, maxSmsLength = MESSAGE_CONTENT_LIMIT }) => {
  const segmentedMessage = useMemo(() => new SegmentedMessage(value), [value]);
  const isOverflowing = useMemo(
    () => segmentedMessage.numberOfCharacters > maxSmsLength,
    [segmentedMessage, maxSmsLength]
  );

  return (
    <Flex justify="space-between" fontSize="sm">
      <Text color={isOverflowing ? "red" : "black"}>
        {segmentedMessage.numberOfCharacters}/{maxSmsLength}
      </Text>
      <Text>
        {segmentedMessage.segmentsCount}{" "}
        {maybePluralize(segmentedMessage.segmentsCount, "segment")}
        <Tooltip
          label={
            <Text align="center">
              Segmentation may vary as it is impacted by special characters in a
              language
            </Text>
          }
          hasArrow
          placement="top"
          borderRadius="md"
        >
          <IconButton
            aria-label="Segmentation Information"
            size="sm"
            icon={<InfoOutlineIcon />}
            variant="ghost"
            color={"black"}
          />
        </Tooltip>
      </Text>
    </Flex>
  );
};
